import RytmWebflow from 'rytm-webflow'

import AmznController from './../AmznController'
import { TweenMax, Expo, Power2 } from 'gsap';

const INSTRUCTIONS_MAX_INTERACTIONS = 10
let interactionsCounter = 0
let mouseMoveAreaSelector = "body"
// let mouseMoveAreaSelector = ".special-inetractive"
// let mouseTargetSelector = "#stage"
let mouseTargetSelector = ".special-area .image-display"

class SpecialController extends RytmWebflow.Controller {
  
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
    this.target = document.querySelector('.special-area .image-display')
    this.mouseTarget = document.querySelector(mouseTargetSelector)
    $(mouseMoveAreaSelector).on('mousemove touchmove', $.proxy(this.onLinkMouseMove, this))
    // window.addEventListener("deviceorientation", this.onDeviceOrient.bind(this))
    interactionsCounter = 0
    this.initInstructions()
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    this.target = null
    this.mouseTarget = null
    $(mouseMoveAreaSelector).off('mousemove touchmove', $.proxy(this.onLinkMouseMove, this))
    // window.removeEventListener("deviceorientation", this.onDeviceOrient.bind(this))
  }

  /**
   * ###########
   * ### OWN ###
   */
  initInstructions() {
    const iconWrapper = document.querySelector('.spacial-instructions .icon-wrapper')
    const phone = document.querySelector('.spacial-instructions .i-phone')
    if (!iconWrapper || !phone) {
      return
    }
    const animTime = 2
    const rotDeg = 10
    let t1 = new TimelineMax({repeat: -1})
    t1.to(iconWrapper, animTime * .5, {x: 50, ease: Power2.easeInOut})
    t1.to(iconWrapper, animTime * .5, {x: 0, ease: Power2.easeInOut})
    phone.style.transform = "rotate(-" + rotDeg + "deg)"
    let t2 = new TimelineMax({repeat: -1})
    t2.to(phone, animTime * .5, {rotation: rotDeg, ease: Power2.easeInOut})
    t2.to(phone, animTime * .5, {rotation: -rotDeg, ease: Power2.easeInOut})
  }
  onDeviceOrient(e) {
    this.percX = this.getOrientationXPerc(e)
    this.updateHoverState()
  }
  getOrientationXPerc(event) {
    const f = (event.alpha + event.beta + event.gamma) / 30
    const perc = Math.abs((Math.sin(f) + 1) / 2 * 100)
    return perc
  }

  onLinkMouseMove(e) {
    this.percX = Math.abs(this.getTargetMouseXPerc(e.pageX))
    this.updateHoverState()
  }
  updateHoverState() {
    if (this.target) {
      this.openPreview()
    } else {
      this.hideAllPreviews()
    }
  }
  registerInteraction() {
    interactionsCounter++
    if (interactionsCounter == INSTRUCTIONS_MAX_INTERACTIONS) {
      const instructions = document.querySelector('.spacial-instructions')
      if (instructions) {
        TweenMax.killTweensOf(instructions);
        let t1 = new TimelineMax({repeat: 0})
        t1.to(instructions, .25, {x: 25, ease: Sine.easeInOut})
        t1.to(instructions, .25, {alpha: 0, onComplete: () => {
          document.documentElement.classList.add("interaction-awareness")  
        }})
        
      } else {
        document.documentElement.classList.add("interaction-awareness")
      }
    }
  }
  openPreview() {
    const newPreview = this.getCurrentPositionPreview()
    if (newPreview) {
      if (!newPreview.classList.contains('active')) {
        const oldPreview = this.getActivePreview();
        if (oldPreview) {
          oldPreview.classList.remove('active')
        }
        newPreview.classList.add('active')
        this.registerInteraction()
      }
    }
  }
  getCurrentPositionPreview() {
    let prev = false
    const previews = this.getAllTargetPreviews()
    const num = previews.length
    if (num > 0) {
      const percPerPrev = Math.round(100 / num)
      let index = Math.floor(this.percX / percPerPrev)
      index = index >= num ? (num - 1) : index
      prev = previews[index]
    }
    return prev
  }
  getTargetMouseXPerc(mouseX) {
    if (!this.mouseTarget || !mouseX) {
      return false
    }
    const rect = this.mouseTarget.getBoundingClientRect()
    const dist1 = mouseX - rect.x
    const p = Math.round(dist1 / rect.width * 100)
    return (p >= 0 && p <= 100) ? p : (p < 0 ? 0 : 100)
  }
  getActivePreview() {
    let prev = false
    const selector = this.getTargetPreviewSelector()
    if (selector) {
      prev = document.querySelector(selector + '.active')
    }
    return prev
  }
  getAllTargetPreviews() {
    let arr = []
    const selector = this.getTargetPreviewSelector()
    if (selector) {
      arr = [...document.querySelectorAll(selector)]
    }
    return arr
  }
  getTargetPreviewSelector() {
    if (!this.target) {
      return false
    }
    return this.target.dataset.selector
  }
  hideAllPreviews() {
    const list = [...document.querySelectorAll('.gallery-preview.active')]
    list.forEach((el) => {
      el.classList.remove('active')
    })
  }

  
}
export default SpecialController